import type { ComponentProps, ReactNode } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type ManageSectionProps = ComponentProps<"div"> & {
  label?: ReactNode
}

function ManageSection(props: ManageSectionProps) {
  const { label, className, children, ...rest } = props
  return (
    <div className={cn("manage-section", className)} {...rest}>
      {label && <div className="manage-section-label">{label}</div>}
      {children}
    </div>
  )
}

export default ManageSection
